export default "__VITE_ASSET__D$$R9btO__"